import { createTheme } from '@mui/material/styles'
import { blue, grey, red } from '@mui/material/colors'
import { appTypography } from '../../typography'
import { datePickerTheme } from '../../datePickerTheme'
import { lightMessageCategoryPalette } from '../shared/messageCategoryPalette'

const lightTheme = createTheme({
  ...datePickerTheme,
  name: 'light',
  typography: appTypography,
  customSizes: {
    drawerWidth: 240
  },
  palette: {
    customColors: {
      praetorianMain: '#1C294D'
    },
    ...lightMessageCategoryPalette,
    deviceInput: {
      background: {
        inactive: blue[900],
        active: red[600]
      },
      text: {
        inactive: grey[100],
        active: grey[100]
      }
    },
    deviceOutput: {
      background: {
        inactive: blue[900],
        active: red[600]
      },
      text: {
        inactive: grey[100],
        active: grey[100]
      }
    }
  }
})

export default lightTheme
